import React from 'react';
import { Paper, Box, Typography } from '@mui/material';

export default function ChartCard({ title, actions, children, height = 400 }) {
  return (
    <Paper sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h6" component="h6" data-pdf-title={title}>{title}</Typography>
        {actions && <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>{actions}</Box>}
      </Box>
      <Box sx={{ height, minHeight: { xs: 280, sm: height } }}>{children}</Box>
    </Paper>
  );
}

